export const messages = [
  // Add your message in the following format
  // Remember to add your picture files in the /public folder
  // {
  //   title: "Hello Bui",
  //   name: "John",
  //   msg: "See you on steam",
  //   coverImg: "./johncover.jpg",
  //   profileImg: "./johnprofile.jpg",
  // },
  {
    coverImg: "./nicetry.jpg",
    title: "",
    msg:
      "Bro, you had a good run. Looking forward to more shit talking. Onward, upward!",
    name: "SY",
    profileImg: "./rem.png",
  },
  {
    coverImg: "./dylancover.jpeg",
    title: "Bye bye Master Imouto",
    msg:
      "So sad to hear you go. Still remember our 3 day pair programming onboarding before you abandon me to go Japan with Bang. All the best with your Vietnam convenience store dreams. Thanks for inculcating the 'master' culture in Web team. Catch you around sometime boss.",
    name: "Dlearn",
    profileImg: "./dylanprofile.jpg",
    rel: "Shadow Shaman Cosplayer",
  },
  {
    title: "Good Luck Bro",
    name: "Chenghua",
    msg:
      "So glad that I've worked with you, thanks for all your guidances. Really learnt alot from you. All the best!",
    coverImg: "./chenghuacover.jpg",
    profileImg: "./chenghuaprofile.png",
  },
  {
    coverImg: "./bangcover.jpg",
    title: "Happy Birthday~~",
    msg: "To you ❤️",
    rel: "Better half of @bangbui",
    name: "Bang, occasionally, Bui",
    profileImg: "./bangprofile.jpg",
  },
  {
    title: "Want to earn $10,000 a month in 5 easy steps?",
    msg:
      "Commit to each day with everything you have. Pour everything you have into what you do.",
    rel: "Sponsored Ad",
    name: "Stiff Tan",
    coverImg: "./supertanbroscover.jpg",
    profileImg: "./supertanbrosprofile.jpeg",
  },
  {
    title: "See you again Bui",
    msg:
      "It's been a blast working with you Bui, I'm going to miss all yours 'WTF' catch phrase. Thanks for helping and teaching me along the ways when we worked together. Wish you nothing but the best of luck and stop watching so much Yaoi lol.",
    rel: "Nooo more bangbui 😭",
    name: "Aaron",
    coverImg: "./aaronlam.png",
    profileImg: "./aaronlam.jpeg",
  },
  {
    title: "I admit nothing but my sadness that you're gone",
    msg:
      "Thanks for all the web-fu, dota-fu, manga-fu and hentai-fu you've shown me",
    rel: "Fellow Apex Mage",
    name: "Ming",
    coverImg: "./mingcc.jpg",
    profileImg: "./mingpp.png",
  },
  {
    title: "It works! I've tried it!",
    msg:
      "Want to grow your PP? Try the ElongatorMax2020 for only $50 a pop right now!",
    rel: "Sponsored Ad",
    name: "ElongatorMax2020",
    coverImg: "./pp.jpg",
    profileImg: "./ppprofile.jpg",
  },
  {
    title: "It's just lonely bang in @bangbui now :(",
    msg:
      "My bro, I thought you like it here with Bang and the web team :( Sad to see you leave, we've been working together for nearly 5 year, going to miss your funny jokes bruh!! If Foodpanda sucks, you are always welcomed at Carousell hahaha",
    rel: "foodpanda sucks",
    name: "Dave",
    coverImg: "./davecover.jpeg",
    profileImg: "./daveprofile.jpeg",
  },
  {
    title: "Ciao Ciao Master Bui",
    msg:
      "It's an honor working with you closely in the vertical homescreen. Thanks for allowing me to steal your knowledge while we were working together. All the best man and give me some vouchers",
    rel: "Imposter",
    name: "Andrew",
    coverImg: "./andrewcover.png",
    profileImg: "./andrewprofile.jpg",
  },
  {
    title: "Best wishes to you, master Bui",
    name: "Jenny",
    msg:
      "So sad that I wasn't able to work with and learn from you in 2020 H1 on web automation as I initially proposed. Thought I'd be able to get back to you in H2 but now you're leaving. :pepesad: Thank you for all your PR comments. Wish you all the best in searching for your next fantastic job either in SG or in VN!",
    coverImg: "./jennycover.jpg",
    profileImg: "./jennyprofile.jpg",
  },
  {
    title: "お疲れ様です",
    name: "clarence",
    msg:
      "Imouto-sensei, a life of zen and enjoyment awaits. Keep working on your goals and hope you'll fulfill your dreams back home in Vietnam! Thanks for being a great teammate, and for your candid insights and the game & show recommendations.",
    coverImg: "./clarencecover.jpg",
    profileImg: "./clarenceprofile.jpg",
  },
  {
    title: "Bye Bye Master Bui",
    msg: "Yo mah bro. Sayonara and all the best.",
    name: "Edward Samuel",
    coverImg: "./edwardcp.jpg",
    profileImg: "./edwardpp.jpg",
  },
  {
    title: "A haiku for Imouto",
    name: "Yamato",
    msg:
      "At the break of dawn - A man dozes on his horse - Warmth finds their faces",
    rel: "Ghost",
    coverImg: "./yaocover.jpg",
    profileImg: "./yaoprofile.jpg",
  },
  {
    title: "My torrent navigator",
    name: "Huiyi",
    msg:
      "thx for everything bui - hope u will go back and set up your convenience store then i can go and visit. miss working with u but change is the only constant. if u believe in it enough, u can do it!",
    rel: "Your favourite PM",
    coverImg: "./seo.jpeg",
    profileImg: "./xfers.png",
  },
  {
    title: "bai bai and all the best",
    name: "N0Ch1ll",
    msg:
      "thank you for making Carousell memorable and enjoyable, i will surely miss the atmosphere you've created. Carousell is not the same without you",
    rel: "Your noob viet bro",
    coverImg: "./n0ch1ll.jpg",
    profileImg: "./p.jpeg",
  },
  {
    title: "WILL MISS HEARING YOUR VOICE FROM XXX KM AWAY",
    name: "Yijun",
    msg: "BUH BYE.",
    rel: "Your fave DA",
    coverImg: "./yijuncover.jpg",
    profileImg: "./yijunprofile.jpg",
  },
  {
    title: "All the best fellow vnese bro!",
    name: "Kim",
    msg:
      "I thought bangbui is forever...turn out it’s not true lol. Joking all the berry best in your next journey wherever it is!!",
    rel: "Your fellow vnese sis",
    coverImg: "./kimcover.jpg",
    profileImg: "./kimprofile.jpg",
  },
  {
    title: "Hello",
    name: "dog",
    msg: "dis is dog",
    rel: "dog",
    coverImg: "disisdog.gif",
  },
];
